// X OAuth PKCE 콜백을 식별하는 search param 키.
// 브라우저 전용 모듈(features/.../shared/oauth.ts)과 edge runtime 미들웨어(apps/web/proxy.ts)가
// 함께 참조하므로, 브라우저 의존성이 없는 순수 상수 모듈에 둬서 양쪽이 공유한다.
export const oauthProviderSearchParamKey = 'oauth-provider';
